
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from '@mui/material';

import DandDAPI from "@dndUtilities/system_api";

import NonFSIndex from "@dndComponents/NonFSIndex";
import AddButton from "@components/input/buttons/AddButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SpellManager from "@dndViews/spell/SpellManager";
// import { Spell } from '@dndModels';
// import ToggleButtonBox from '@components/input/buttons/ToggleButtonBox';
// import DisplayObjects from '../../components/display/DisplayObjects';

const api = DandDAPI.getInstance();

export default function SpellIndex() {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  // const [use_extra_filter, setUseExtraFilter] = useState(true);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          width={800}
          onClose={() => { setOpen(false); }}>
          <SpellManager />
        </ModalOrDrawer>
      </>
    );
  }
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (reloading) {
    return <></>;
  } else {
    return (
      <>
        <NonFSIndex
          data_type="spell"
          // save_all
          // name_display={(obj: ModelBase | PlayerObject) => {
          //   if (obj instanceof Spell) {
          //     return (
          //       <ViewSpell
          //         spell={obj}
          //         show_ritual
          //         hide_details
          //       />
          //     );
              
          //     // return <>{ obj.use_name } (<DisplayObjects type='source_book' ids={obj.source_book_ids} />)</>;
          //   }
          //   return <></>;
          // }}
          extra_by_add={api.user && api.user.admin ? () => {
            // debugger;
            return (
              <>
                &nbsp;
                <AddButton
                  label="Parse Add"
                  onClick={() => {
                    setNavigateTo(`/dandd/spell/parse_add`);
                  }}
                />
                &nbsp;
                <Button
                  variant="contained" color="primary" 
                  onClick={() => {
                    setOpen(true);
                  }}>
                  Spell Manager
                </Button>
                {/* &nbsp;
                <ToggleButtonBox
                  name="Use Extra Filter"
                  value={use_extra_filter}
                  onToggle={() => { {
                    setUseExtraFilter(!use_extra_filter);
                    setReloading(true);
                  }}}
                /> */}
              </>
            );
          } : undefined}
          // save_all
          // extra_filter={(obj) => {
          //   if (use_extra_filter) {
          //     if (obj instanceof Spell) {
          //       if (obj.upcast_string.length === 0) {
          //         return true;
          //       }
          //       // if (obj.source_book_ids.includes("60a9c9ed891e971c782a76a1") && !obj.source_book_ids.includes("63cd69a14d337b1738dab548")) {
          //       //   // It's in PHB 5e and not SRD 5.1
          //       //   // Look for a variant on SRD 5.1
          //       //   return !obj.variant_group.some(o => o.source_book_ids.includes("63cd69a14d337b1738dab548"));
          //       // }
          //       // if (!obj.source_book_ids.includes("60a9c9ed891e971c782a76a1") && obj.source_book_ids.includes("63cd69a14d337b1738dab548")) {
          //       //   // It's in SRD 5.1 and not in PHB 5e 
          //       //   // Look for a variant on PHB 5e
          //       //   return !obj.variant_group.some(o => o.source_book_ids.includes("60a9c9ed891e971c782a76a1"));
          //       // }
          //       // if (obj.source_book_ids.includes("6675b302a4476741138fa22b") && !obj.source_book_ids.includes("695ae0f0cfa83df9124cb5ac")) {
          //       //   // It's in PHB 5.5e and not SRD 5.2
          //       //   // Look for a variant on SRD 5.2
          //       //   return !obj.variant_group.some(o => o.source_book_ids.includes("695ae0f0cfa83df9124cb5ac"));
          //       // }
          //       // if (!obj.source_book_ids.includes("6675b302a4476741138fa22b") && obj.source_book_ids.includes("695ae0f0cfa83df9124cb5ac")) {
          //       //   // It's in SRD 5.2 and not in PHB 5.5e 
          //       //   // Look for a variant on PHB 5.5e
          //       //   return !obj.variant_group.some(o => o.source_book_ids.includes("6675b302a4476741138fa22b"));
          //       // }
          //     }
          //     return false;
          //   }
          //   return true;
          // }}
          // log_it
          // sort={(obj1: ModelBase | PlayerObject, obj2: ModelBase | PlayerObject) => {
          //   if (obj1 instanceof Spell && obj2 instanceof Spell) {
          //     // return obj1.true_name.localeCompare(obj2.true_name);
          //     return obj1.level > obj2.level ? 1 : (obj1.level === obj2.level ? 0 : -1);
          //   }
          //   return 0;
          // }}
          quick_fields={["school","spell_level","spell_list"]}
        />
        { renderExtras() }
      </>
    );
  }
}